const styles = {
  container: '',

  list: 'grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-8',

  images: {
    container: 'grid grid-cols-3 gap-6',
    item: 'relative aspect-square w-full group overflow-hidden cursor-pointer',
    image:
      'object-cover group-hover:scale-105 transition-all duration-300 cursor-pointer',
  },
};

export default styles;
